module.exports = __webpack_public_path__ + "static/media/icn_call_fisdom.90893dac.svg";